export const DEVICE_CONNECTIVITY_CHANGED_EVENT_NAME =
  'com.hp.jarvis.device.event.connectivity.changed';
